<template>
  <div class="searchAndTable"
       v-loading.fullscreen.lock="fullscreenLoading"
       element-loading-text="处理中…… 请耐心等待"
       element-loading-spinner="el-icon-loading" v-cloak>
    <el-tabs type="border-card" v-model="searchFormData.reservationType" @tab-click="tabClick">
      <el-tab-pane label="仪器预约" name="1" >
        <el-row class="searForm" :inline="true" size="small">
          <el-form label-width="100px" ref="searchForm" :inline="true">
            <el-form-item label="设备名称">
              <el-input size="small" v-model="searchFormData.equName"></el-input>
            </el-form-item>
            <el-form-item label="项目名称">
              <el-input size="small" v-model="searchFormData.itemName"></el-input>
            </el-form-item>
            <el-form-item label="实验室名称">
              <el-input size="small" v-model="searchFormData.labName"></el-input>
            </el-form-item>
            <el-form-item label="审核状态">
              <el-select style="width: 200px" size="small" v-model="searchFormData.status" placeholder="请选择">
                <el-option label="全部" value=""></el-option>
                <el-option label="待审核" value="0"></el-option>
                <el-option label="通过" value="1"></el-option>
                <el-option label="驳回" value="2"></el-option>
                <el-option label="使用中" value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button  type="primary" size="small" @click="searchButton">搜索</el-button>
            </el-form-item>
          </el-form>
        </el-row>
        <el-row class="paginationS">
          <el-pagination @size-change="pageSizeChange" @current-change="pageChange"
                         :current-page="searchFormData.page"
                         :page-sizes="[10, 40, 50, 60]" :page-size="searchFormData.pageSize"
                         layout="total, sizes, jumper, next, pager, prev" :total="total">
          </el-pagination>
        </el-row>
        <!--表格控件-->
        <el-table stripe :data="tableData" border style="width: 100%"
                  :header-cell-style="{color:'#0B52A3',textAlign:'center'}"
                  :cell-style="{color:'#000',textAlign:'center'}">
          <el-table-column type="selection"></el-table-column>
          <el-table-column prop="labEquInfos.equNum" min-width="100px" label="设备编号"></el-table-column>
          <el-table-column prop="labEquInfos.equName" min-width="100px" label="设备名称"></el-table-column>
          <el-table-column prop="itemName" min-width="100px" label="项目名称"></el-table-column>
          <el-table-column prop="insCNName" width="150px" label="设备负责人">
            <template slot-scope="scope">
              <el-popover placement="left" width="270" trigger="hover" v-if="scope.row.labEquInfos">
                <el-table :data="scope.row.labEquInfos.equManagerRelations">
                  <el-table-column width="240" property="userName" label="名称"></el-table-column>
                </el-table>
                <el-button slot="reference" size="mini" style="width: 120px;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">
                  设备负责人</el-button>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="labName" min-width="100px" label="所属实验室"></el-table-column>
          <el-table-column prop="usersName" min-width="100px" label="申请人"></el-table-column>
          <el-table-column prop="payNum" width="150px" label="预约时间">
            <template slot-scope="scope">
              <el-popover placement="left" width="500" trigger="hover">
                <el-table :data="scope.row.equReservationPeriods">
                  <el-table-column width="230" property="userName" label="开始时间">
                    <template slot-scope="scope">
                      <span>{{new Date(scope.row.startTime).format('yyyy-MM-dd HH:mm:ss')}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column width="230" property="userName" label="结束时间">
                    <template slot-scope="scope">
                      <span>{{new Date(scope.row.endTime).format('yyyy-MM-dd HH:mm:ss')}}</span>
                    </template>
                  </el-table-column>
                </el-table>
                <el-button slot="reference" size="mini" style="width: 120px;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">
                  预约时间</el-button>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="statusName" width="160px" label="审核状态"></el-table-column>
          <el-table-column width="100px" fixed="right" label="操作" v-if="searchFormData.type != 'apply'">
            <template slot-scope="row">
              <el-link type="primary" :underline="false" style="margin-left: 3px" v-if="row.row.statusInfo && row.row.statusInfo.status == '0'" @click="auditApplyEqu(row.row)">
                审核</el-link>
              <!--当权限为设备负责人并且通过时才会出现领用按钮-->

              <el-link type="primary" :underline="false" style="margin-left: 3px"
                       @click="goDetail('look',row.row)">
                查看</el-link>
              <!--要迁移的-->
              <el-link type="primary" :underline="false" style="margin-left: 3px" v-if="row.row.flag == '1' && searchFormData.type == 'audit2'" @click="receiveEqu(row.row)">
                领用</el-link>
              <el-link type="primary" :underline="false" style="margin-left: 3px" v-if="row.row.flag == '1' && searchFormData.type == 'audit2'" @click="returnEqu(row.row)">
                归还</el-link>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>

      <el-tab-pane label="送样预约" name="2">
        <el-row class="searForm">
          <el-form label-width="100px" ref="searchForm" :inline="true" size="small">
            <el-form-item label="设备名称">
              <el-input size="small" v-model="searchFormData.equName"></el-input>
            </el-form-item>
            <el-form-item label="项目名称">
              <el-input size="small" v-model="searchFormData.itemName"></el-input>
            </el-form-item>
            <el-form-item label="实验室名称">
              <el-input size="small" v-model="searchFormData.labName"></el-input>
            </el-form-item>
            <el-form-item label="申请人">
              <el-input size="small" v-model="searchFormData.userName"></el-input>
            </el-form-item>
            <el-form-item label="预约时间">
              <el-date-picker
                style="width: 200px"
                v-model="searchFormData.reservationDate"
                type="date"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                placeholder="请选择">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="审核状态">
              <el-select style="width: 200px" v-model="searchFormData.status" placeholder="请选择">
                <el-option label="全部" value=""></el-option>
                <el-option label="待审核" value="0"></el-option>
                <el-option label="通过" value="1"></el-option>
                <el-option label="驳回" value="2"></el-option>
                <el-option label="使用中" value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button  type="primary" size="small" @click="searchButton">搜索</el-button>
            </el-form-item>
          </el-form>
        </el-row>
        <el-row class="operation">
          <div style="float: left;">
            <el-button class="operaButton" type="text" size="small">导出Excel</el-button>
          </div>
        </el-row>
        <el-row class="paginationS">
          <el-pagination @size-change="pageSizeChange" @current-change="pageChange"
                         :current-page="searchFormData.page"
                         :page-sizes="[10, 40, 50, 60]" :page-size="searchFormData.pageSize"
                         layout="total, sizes, jumper, next, pager, prev" :total="total">
          </el-pagination>
        </el-row>
        <!--表格控件-->
        <el-table stripe :data="tableData" border style="width: 100%"
                  :header-cell-style="{color:'#0B52A3',textAlign:'center'}"
                  :cell-style="{color:'#000',textAlign:'center'}">
          <el-table-column prop="labEquInfos.equNum" min-width="100px" label="设备编号"></el-table-column>
          <el-table-column prop="labEquInfos.equName" min-width="100px" label="设备名称"></el-table-column>
          <el-table-column prop="itemName" min-width="100px" label="项目名称"></el-table-column>
          <el-table-column prop="sampleShap" min-width="100px" label="样品形态"></el-table-column>
          <el-table-column prop="syr" width="120px" label="送样人"></el-table-column>
          <el-table-column prop="useOrgName" min-width="100px" label="送样单位"></el-table-column>
          <el-table-column prop="payNum" width="150px" label="送样时间">
            <template slot-scope="scope">
              <el-popover placement="left" width="500" trigger="hover">
                <el-table :data="scope.row.equReservationPeriods">
                  <el-table-column width="230" property="userName" label="开始时间">
                    <template slot-scope="scope">
                      <span>{{new Date(scope.row.startTime).format('yyyy-MM-dd HH:mm:ss')}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column width="230" property="userName" label="结束时间">
                    <template slot-scope="scope">
                      <span>{{new Date(scope.row.endTime).format('yyyy-MM-dd HH:mm:ss')}}</span>
                    </template>
                  </el-table-column>
                </el-table>
                <el-button slot="reference" size="mini" style="width: 120px;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">
                  送样时间</el-button>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="statusName" width="140px" label="审核状态"></el-table-column>
          <el-table-column width="80px" fixed="right" label="操作" v-if="searchFormData.type != 'apply'">
            <template slot-scope="row">
              <el-link type="primary" :underline="false" style="margin-left: 3px" v-if="row.row.statusInfo && row.row.statusInfo.status == '0'" @click="auditApplyEqu(row.row)">
                审核</el-link>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>

    <el-dialog title="审核" :visible.sync="auditDialog" width="600px">
      <el-form size="small" label-width="100px">
        <el-form-item label="审核意见">
          <el-input type="textarea" :rows="5" v-model="auditInfo.remark" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="display: flex;justify-content: center">
        <el-button size="small" type="danger" @click="auditAppEqu(2)">驳回</el-button>
        <el-button size="small" type="success" @click="auditAppEqu(1)">通过</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="领用"
      :visible.sync="faultDilog"
      width="50%">
      <el-form ref="receiveObj" :model="receiveObj" label-width="140px" size="small" :inline="true" :rules="rules_receive">
        <el-form-item label="项目名称" class="subObj" prop="itemName">
          <el-input v-model="receiveObj.itemName" disabled></el-input>
        </el-form-item>
        <el-form-item label="领用时间" class="subObj" prop="receiveAddDate">
          <el-date-picker
            style="width: 200px"
            v-model="receiveObj.receiveAddDate"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="请选择">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="申请人" class="subObj" prop="InsName">
          <el-input v-model="rowInfo.usersName" disabled></el-input>
        </el-form-item>
        <el-form-item label="电话" class="subObj" prop="InsName">
          <el-input v-model="rowInfo.userTel" disabled></el-input>
        </el-form-item>
        <el-form-item label="领用人" class="subObj" prop="receiveUser">
          <el-input v-model="receiveObj.receiveUser" ></el-input>
        </el-form-item>
        <el-form-item label="电话" class="subObj" prop="receivePhone">
          <el-input v-model="receiveObj.receivePhone"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" size="small" @click="faultDilog = false">取消领用</el-button>
        <el-button type="primary" size="small" @click="subReceiveObj">确定领用</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="归还"
      :visible.sync="sempleInfoDilog"
      width="50%">
      <el-form ref="returnObj" :model="returnObj" label-width="120px" size="small" :inline="true" :rules="rules_return">
        <el-form-item label="项目名称" class="subObj" prop="itemName">
          <el-input v-model="returnObj.itemName" disabled></el-input>
        </el-form-item>
        <el-form-item label="归还时间" class="subObj" prop="equGddate">
          <el-date-picker
            style="width: 200px"
            v-model="returnObj.equGddate"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="请选择">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="申请人" class="subObj" prop="InsName">
          <el-input v-model="rowInfo.usersName" disabled></el-input>
        </el-form-item>
        <el-form-item label="电话" class="subObj" prop="InsName">
          <el-input v-model="rowInfo.userTel" disabled></el-input>
        </el-form-item>
        <el-form-item label="归还人" class="subObj" prop="returnUser">
          <el-input v-model="returnObj.returnUser"></el-input>
        </el-form-item>
        <el-form-item label="归还人电话" class="subObj" prop="returnPhone">
          <el-input v-model="returnObj.returnPhone"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" size="small" @click="sempleInfoDilog = false">取消归还</el-button>
        <el-button type="primary" size="small" @click="subReturnObj">确定归还</el-button>
      </span>
    </el-dialog>

    <el-dialog title="预约信息记录"
               :visible.sync="detailDialog"
               width="950px"
               :close-on-click-modal='false'
               class="bodyDialog">
      <div class="sor-table">

        <div class="table-row clearfix">
          <div class="table-col w150">设备名称：</div>
          <div class="table-col w300">{{addData.inName}}</div>
          <div class="table-col w150">项目名称：</div>
          <div class="table-col w300">{{addData.itemName}}</div>
        </div>

        <div class="table-row clearfix">
          <div class="table-col w150">负责人：</div>
          <div class="table-col w300">{{addData.equPersonName}}</div>
          <div class="table-col w150">所属实验室：</div>
          <div class="table-col w300">{{addData.labName}}</div>
        </div>

        <div class="table-row clearfix">
          <div class="table-col w150">申请人：</div>
          <div class="table-col w300">{{addData.usersName}}</div>
          <div class="table-col w150">申请单位：</div>
          <div class="table-col w300">{{addData.useOrgName}}</div>
        </div>

        <div class="table-row clearfix">
          <div class="table-col w150">使用性质：</div>
          <div class="table-col w300">{{addData.equUsewayName}}</div>
          <div class="table-col w150">使用地点：</div>
          <div class="table-col w300"><!--{{addData.dataJsonObj.addressName}}--></div>
        </div>

        <div class="table-row clearfix">
          <div class="table-col w150">电话：</div>
          <div class="table-col w300">{{addData.userTel}}</div>
          <div class="table-col w150">电子邮件：</div>
          <div class="table-col w300">{{addData.userEmail}}</div>
        </div>

        <div class="table-row clearfix">
          <div class="table-col w150" :style="'height:'+timeHeight+'px'">预约时间：</div>
          <div class="table-col w300" :style="'height:'+timeHeight+'px'">
            <p v-for="(item,index) in addData.orderTime" :key="index">{{item}}</p>
          </div>
          <div class="table-col w150" :style="'height:'+timeHeight+'px'">操作人数量：</div>
          <div class="table-col w300" :style="'height:'+timeHeight+'px'"></div>
        </div>

        <div class="table-row clearfix">
          <div class="table-col w150">指导老师：</div>
          <div class="table-col w300">{{addData.teacherName}}</div>
          <div class="table-col w150">实际用时：</div>
          <div class="table-col w300"></div>
        </div>

        <div class="table-row clearfix">
          <div class="table-col w150" style="height: 130px">预约明细：</div>
          <div class="table-col"
               style="width: 750px;
               height: 130px;
               padding: 20px;
               line-height: 20px">

            <div class="mini-table">

              <div class="mini-table-row clearfix">
                <div class="mini-table-col">收费项目</div>
                <div class="mini-table-col">计费方式</div>
                <div class="mini-table-col">预计金额</div>
              </div>

              <div class="mini-table-row clearfix"
                   v-for="(item,index) in calcEquList"
                   :key="index">
                <div class="mini-table-col">{{item.name}}</div>
                <div class="mini-table-col">{{item.calcType}}</div>
                <div class="mini-table-col">{{item.money}}</div>
              </div>

              <div class="mini-table-row"
                   style="border-right: 1px solid black;text-align: center;">
                总计：
              </div>

            </div>
          </div>
        </div>

        <div class="table-row clearfix">
          <div class="table-col w150">备注：</div>
          <div class="table-col" style="width: 750px">{{addData.remark}}</div>
        </div>

        <div class="table-row clearfix">
          <div class="table-col w150">审核状态：</div>
          <div class="table-col" style="width: 750px">{{addData.auditStatus}}</div>
        </div>

      </div>
      <span slot="footer" class="dialog-footer" style="display: flex;justify-content: center;align-items: center">
            <el-button @click="detailDialog = false" size="small">取消</el-button>
            <el-button type="primary" @click="subAudit" size="small" v-show="dialogIsEdit">保存</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
  // 将提交数据转化为formData
  function translateForm(data) {
    var fd = new FormData();
    for (var key in data) {
      fd.append(key, data[key])
    }
    return fd;
  }

  Date.prototype.format = function(fmt)
  {
    var o = {
      "M+" : this.getMonth()+1, //月份
      "d+" : this.getDate(), //日
      "h+" : this.getHours()%12 == 0 ? 12 : this.getHours()%12, //小时
      "H+" : this.getHours(), //小时
      "m+" : this.getMinutes(), //分
      "s+" : this.getSeconds(), //秒
      "q+" : Math.floor((this.getMonth()+3)/3), //季度
      "S" : this.getMilliseconds() //毫秒
    };
    if(/(y+)/.test(fmt))
      fmt=fmt.replace(RegExp.$1, (this.getFullYear()+"").substr(4 - RegExp.$1.length));
    for(var k in o)
      if(new RegExp("("+ k +")").test(fmt))
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
    return fmt;
  }

  export default {
    name: "",
    props:{
      sentType:{
        type:String,
        default:''
      }
    },
    data(){
      return{
        addData:{},
        timeHeight:40,
        dialogIsEdit:false,
        detailDialog:false,//查看详情
        language:'zh_CN',
        fullscreenLoading:false,
        faultDilog:false,//故障上传的模态框
        sempleInfoDilog:false,//样品登记信息的模态框
        auditDialog:false,//审核模态框
        searchFormData:{
          page: 1,
          pageSize: 10,
          type:'',//审核状态 apply-预约列表；audit1-学院管理员审核；audit2-实验室负责人；audit3中心主任；audit4-导师
          reservationType:'1',//设备预约类型 1设备预约 2 样本检测
          equName:'',//仪器名称
          userName:'',//申请人
          labName:'',//实验室名称
          itemName:'',//项目名称
          status:'',
        },
        total: 0,
        tableData:[],//审核列表
        mainSelectArr:[],//被选中的仪器列表
        receiveObj:{
          equId:'',
          equName:'',
          equNumber:'',
          itemName:'',//项目名称
          receiveAddDate:'',//领用时间
          receiveUser:'',//领用人姓名
          receivePhone:'',//领用人电话
        },//领用信息
        returnObj:{
          equId:'',
          equName:'',
          equNumber:'',
          itemName:'',//项目名称
          equGddate:'',
          returnUser:'',//归还人
          returnPhone:'',//归还人手机
        },
        auditInfo:{
          reservationId:'',
          remark:'',
          status:'',
          auditFlowId:''
        },
        rowInfo:{},//选中某一行的详细信息
        rules_receive:{
          receiveAddDate:[{ required: true, message: '请输入领用时间', trigger: 'blur' }],
          receiveUser:[{ required: true, message: '请输入领用人', trigger: 'blur' }],
          receivePhone:[{ required: true, message: '请输入领用人手机号码', trigger: 'blur' }],
        },
        rules_return:{
          equGddate:[{ required: true, message: '请输入归还时间', trigger: 'blur' }],
          returnUser:[{ required: true, message: '请输入归还人姓名', trigger: 'blur' }],
          returnPhone:[{ required: true, message: '请输入归还人手机号码', trigger: 'blur' }],
        },
        detailList:[],//预约详情
        calcEquList: [
          //预约明细里的小表格
          {
            name: '打印机',
            calcType: '按样品数计算',
            money: "1000"
          },
          {
            name: '加急费',
            calcType: '按样品数计算',
            money: '1000'
          }
        ],
      }
    },
    watch:{
      'sentType': function(a,b){
        //a是value的新值，b是旧值 如果是对象的话监听不到变化
        var that = this;
        that.searchFormData.type = a
        that.getAuditList()

      },

      $route(to,from){
        var that = this;
        that.searchFormData.type = to.params.type;
        that.getAuditList()
      },
      '$i18n.locale':function(val){
        this.language = val
      }
    },
    methods:{
      subAudit() {
        //提交审批意见
      },
      //获取设备明细
      getBillingByUser(row){
        var that = this;
        that.fullscreenLoading = true;
        var fd = new FormData();
        fd.append('equId', row.equId);
        fd.append('billingType', 'Instruments');

        axios.post("/newEqu/getBillingByUser",fd).then(function (response) {
          that.fullscreenLoading = false;
          var resData = response.data;
          that.detailList = [];
          if(resData.sampleBilling){
            resData.type = '样品计费';
            resData.price = resData.sampleBilling;
            that.detailList.push(resData)
          }else if(resData.numberBilling){
            resData.type = '次数计费';
            resData.price = resData.numberBilling;
            that.detailList.push(resData)
          }else if(resData.timeBilling){
            resData.type = '时间计费（分钟）';
            resData.price = resData.numberBilling;
            that.detailList.push(resData)
          };
        }).catch(function (error) {
          that.fullscreenLoading = false;
          that.$message.error('获取设备详情失败，请重试！');
        })
      },
      getDetail(row) {
        var that = this;

        var fd = new FormData();
        fd.append('id', row.id)
        that.fullscreenLoading = true;
        axios.post("newEqu/getReservationDetail", fd, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(function (response) {
          var res = response.data
          that.addData = res

          that.$set(that.addData,'dataJsonObj',JSON.parse(that.addData.dataJson))
          var name = ''
          if(that.$i18n.locale=='zh_CN'){
            name = that.addData.labEquInfos.equName?that.addData.labEquInfos.equName:' '
          }else if(that.$i18n.locale=='en_US'){
            name = that.addData.labEquInfos.englishName?that.addData.labEquInfos.englishName:' '
          }else if(that.$i18n.locale=='ru_RU'){
            name = that.addData.labEquInfos.russianName?that.addData.labEquInfos.russianName:" "
          }
          that.$set(that.addData,'inName',name)

          var fzrList = [];
          that.addData.labEquInfos.equManagerRelations.forEach((item,index)=>{
            fzrList.push(item.userName)
          })
          var fzrName=fzrList.toString()
          that.$set(that.addData,'equPersonName',fzrName)
          var equUseway =that.addData.labEquInfos.equUseway;
          var syfx = equUseway=='0'?'科研':equUseway=='1'?'教学':'其他'
          that.$set(that.addData,'equUsewayName',syfx)

          var orderTime = []
          that.addData.equReservationPeriods.forEach((item,index)=>{
            var startTimeName = new Date(item.startTime).format('yyyy-MM-dd HH:mm:ss')
            var endTimeName = new Date(item.endTime).format('yyyy-MM-dd HH:mm:ss')
            var time = startTimeName+'--'+endTimeName
            orderTime.push(time)
          })
          that.$set(that.addData,'orderTime',orderTime)
          that.$set(that.addData,'auditStatus',row.statusName)

          that.timeHeight = that.addData.orderTime.length * 40

          that.fullscreenLoading = false;
        }).catch(function (error) {
          that.fullscreenLoading = false;
          that.$message({
            message: '数据请求失败，请重试。',
            type: 'error'
          });
        })
      },
      goDetail(type, row){
        //查看预约详情
        if (type == 'edit' || type == 'look') {
          this.getBillingByUser(row)
          this.getDetail(row)
        }
        if (type == 'edit' || type == 'add') {
          this.dialogIsEdit = true
        } else {
          this.dialogIsEdit = false
        }
        this.detailDialog = true
      },
      // 获取审核列表
      getAuditList(){
        var that = this;
        var fd = translateForm(that.searchFormData);
        that.fullscreenLoading = true;
        axios.post("/newEqu/getEquReservationList",fd).then(function (response) {
          that.fullscreenLoading = false;
          var resData = response.data;
          that.tableData = resData.data;
          for(var i=0;i<that.tableData.length;i++){
            var item = that.tableData[i];
            if(item.flag == '0'){
              that.$set(item,'statusName','待审核')
            }else if(item.flag == '1'){
              that.$set(item,'statusName','审核通过')
            }else if(item.flag == '2'){
              that.$set(item,'statusName','驳回')
            }else{
              if(that.searchFormData.type == 'audit1'){
                for(var j=0;j<item.equAuditFlowSet.length;j++){
                  var res = item.equAuditFlowSet[j];
                  if(res.status == '0'){
                    that.$set(item,'statusName','待'+res.userTypeName+'审核')
                    if(res.userTypeName == '学院管理员'){
                      that.$set(item,'statusInfo',res)};
                  };
                }
              }else if(that.searchFormData.type == 'audit2'){
                for(var j=0;j<item.equAuditFlowSet.length;j++){
                  var res = item.equAuditFlowSet[j];
                  if(res.status == '0'){
                    that.$set(item,'statusName','待'+res.userTypeName+'审核')
                    if(res.userTypeName == '设备负责人'){
                      that.$set(item,'statusInfo',res)};
                  };
                }
              }else if(that.searchFormData.type == 'audit3'){
                for(var j=0;j<item.equAuditFlowSet.length;j++){
                  var res = item.equAuditFlowSet[j];
                  if(res.status == '0'){
                    that.$set(item,'statusName','待'+res.userTypeName+'审核');
                    if(res.userTypeName == '实验中心主任'){
                      that.$set(item,'statusInfo',res)
                    };
                  };
                };
              }else if(that.searchFormData.type == 'audit4'){
                for(var j=0;j<item.equAuditFlowSet.length;j++){
                  var res = item.equAuditFlowSet[j];
                  if(res.status == '0'){
                    that.$set(item,'statusName','待'+res.userTypeName+'审核')
                    if(res.userTypeName == '导师'){
                      that.$set(item,'statusInfo',res)
                    };
                  };
                };
              }else{
                item.equAuditFlowSet.forEach((res) => {
                  if(res.status == '0'){that.$set(item,'statusName','待'+res.userTypeName+'审核')};
                });
              }
            }
          };
          that.total = resData.total;
        }).catch(function (error) {
          that.fullscreenLoading = false;
          that.$message.error('保存失败，请重试！');
        })
      },
      //每页条数变化
      pageSizeChange(val){
        this.searchFormData.pageSize = val;
        this.searchFormData.page = 1;
        this.getAuditList()
      },
      //页码变化
      pageChange(val){
        this.searchFormData.page = val;
        this.getAuditList()
      },
      // 条件查询审核列表
      searchButton(){
        this.searchFormData.page = 1;
        this.getAuditList()
      },
      tabClick(){
        this.searchButton()
      },
      //打开审核模态框
      auditApplyEqu(info){
        this.auditDialog = true;
        this.auditInfo.reservationId = info.id;
        this.auditInfo.auditFlowId = info.statusInfo.id;
      },
      auditAppEqu(status){
        var that = this;
        that.auditInfo.status = status;
        var fd = translateForm(that.auditInfo);
        that.fullscreenLoading = false;
        axios.post("/newEqu/saveAudit",fd).then(function (response) {
          that.fullscreenLoading = false;
          if(response.data.code == 2){
            that.$message.success('审核成功！');
            that.auditDialog = false;
            that.searchButton();
          }else if(response.data.code == -4){
            that.$message.error('时间冲突，请重新预约！');
          }else{
            that.$message.error('审核失败，请重试！');
          }
        }).catch(function (error) {
          that.fullscreenLoading = false;
          that.$message.error('审核失败，请重试！');
        });
      },
      // 样品领用
      receiveEqu(row){
        this.rowInfo = row;
        this.faultDilog = true;
        this.receiveObj.itemName = row.itemName;
        this.receiveObj.equId = row.equId;
        this.receiveObj.equName = row.labEquInfos.equName;
        this.receiveObj.equNumber = row.labEquInfos.equNum;
      },
      // 提交领用
      subReceiveObj(){
        var that = this;
        that.$refs.receiveObj.validate((val) => {
          if(val){
            var fd = translateForm(that.receiveObj);
            that.fullscreenLoading = false;
            axios.post("/newEqu/saveEquReceive",fd).then(function (response) {
              that.fullscreenLoading = false;
              if(response.data.code == 2){
                that.$message.success('领用成功！');
                that.faultDilog = true;
                that.searchButton();
              }else{
                that.$message.error('领用失败，请重试！');
              }
            }).catch(function (error) {
              that.fullscreenLoading = false;
              that.$message.error('领用失败，请重试！');
            });
          }else{
            that.$message.warning('请将表单填写完整！');
          }
        })
      },
      // 样品归还
      returnEqu(row){
        this.rowInfo = row;
        this.sempleInfoDilog = true;
        this.returnObj.itemName = row.itemName;
        this.returnObj.equId = row.equId;
        this.returnObj.equName = row.labEquInfos.equName;
        this.returnObj.equNumber = row.labEquInfos.equNum;
      },
      //提交归还记录
      subReturnObj(){
        var that = this;
        that.$refs.returnObj.validate((val) => {
          if(val){
            var fd = translateForm(that.returnObj);
            that.fullscreenLoading = false;
            axios.post("/newEqu/saveEquReceive",fd).then(function (response) {
              that.fullscreenLoading = false;
              if(response.data.code == 2){
                that.$message.success('领用成功！');
                that.sempleInfoDilog = false;
                that.searchButton();
              }else{
                that.$message.error('领用失败，请重试！');
              }
            }).catch(function (error) {
              that.fullscreenLoading = false;
              that.$message.error('领用失败，请重试！');
            });
          }else{
            that.$message.warning('请将表单填写完整！');
          }
        });
      }
    },
    created(){
      var that = this;
      that.searchFormData.type = that.$route.params.type;
      that.getAuditList()
    }
  }
</script>

<style scoped>
  .subObj{
    margin-top: 15px;
    width: 400px;
  }
  .subObj .el-form-item{

  }
  .el-date-editor.el-input, .el-date-editor.el-input__inner{
    width: 100%;
  }
  .clearfix:after,
  .clearfix:before {
    content: ''; /*IE6，7下不兼容*/
    display: table;
  }

  .clearfix:after {
    clear: both;
  }

  .clearfix {
    *zoom: 1;
  }

  /*表格*/
  .sor-table {
    border-left: 1px solid black;
    border-bottom: 1px solid black;
    width: 900px;
    box-sizing: unset;
  }

  .table-row {
    width: 900px;
    border-top: 1px solid black;
  }

  .table-col {
    box-sizing: border-box;

    float: left;
    min-height: 40px;
    line-height: 40px;
    padding-left: 5px;
    border-right: 1px solid black;
  }

  .mini-table {
    box-sizing: border-box;

    margin-left: 50px;
    border-left: 1px solid black;
    border-bottom: 1px solid black;
    width: 600px;
    box-sizing: unset;
  }


  .mini-table-row {
    width: 600px;
    box-sizing: border-box;

    border-top: 1px solid black;
  }

  .mini-table-col {
    float: left;
    min-height: 20px;
    line-height: 20px;
    padding-left: 5px;
    border-right: 1px solid black;
    width: 200px;
    box-sizing: border-box;

  }

  .w150 {
    width: 150px;
  }

  .w300 {
    width: 300px;
  }
</style>
